// src/components/Public/SearchResults.js
import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function SearchResults() {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('q') || '';
  
  return (
    <>
      <Helmet>
        <title>Search Results for "{searchQuery}" | Property Listings</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={containerStyle}>
        <h1>Search Results for "{searchQuery}"</h1>
        <p>This feature will be available soon. Advanced search is coming!</p>
        <Link to="/" style={linkStyle}>← Back to All Properties</Link>
      </div>
    </>
  );
}

// Styles
const containerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '40px 20px',
  textAlign: 'center',
};

const linkStyle = {
  display: 'inline-block',
  marginTop: '20px',
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '5px',
  fontWeight: 'bold',
};

export default SearchResults;